// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"8c6b1ef5","973":"122d96b8"}[chunkId] + ".chunk.js";
};